/**
 * The CMSBlockTeaser component
 */
import React from "react";
import PropTypes from "prop-types";
import { Card, CardTitle, CardBody, Row, Col } from "reactstrap";
import ResponsivePicture from "../../ResponsivePicture";
import LazyLoad from "react-lazyload";

/**
 * Stateless react component to render the CMSBlockTeaser component
 * @param {Object} props the props passed to the page.
 */
const CMSBlockTeaser = (props, context) => {
  const { cmsBlock } = props;
  if (cmsBlock.image) {
    // Since Teasers are very small we only take the smalest image to save loading time.
    var imgSrcs = "";
    var webpImgSrcs = "";
    try {
      var lastImg = cmsBlock.image[cmsBlock.image.length - 1];
      imgSrcs = `${lastImg.url} ${lastImg.size}`;
      // cmsBlock.image.forEach(image =>
      //   imgSrcs += `${image.url} ${image.size}, `
      // );
      // imgSrcs = imgSrcs.replace(/,\s*$/, "");

      webpImgSrcs = `${lastImg.webp_url} ${lastImg.size}`;
      // cmsBlock.image.forEach(image =>
      //   webpImgSrcs += `${image.webp_url} ${image.size}, `
      // );
      // webpImgSrcs = webpImgSrcs.replace(/,\s*$/, "");
    } catch (e) {
      console.log("no image url found");
    }
  }
  // <Picture
  // className="card-img-top"
  // sources={[
  //   { srcSet: webpImgSrcs, type: "image/webp" },
  //   { srcSet: imgSrcs, type: "image/jpeg" }
  // ]}
  // sizes="(min-width: 87.5em) calc(466.66px - 30px),(min-width: 75em) calc(33.33vw - 30px), (min-width: 62em) calc(360px - 30px), (min-width: 48em) calc(540px - 30px), (min-width: 36em) calc(100vw - 30px)"
  // alt={cmsBlock.title}
  // loading="lazy" />
  return (
    <Card className="cmsblock__teaser">
      {lastImg && (
        <a href={cmsBlock.primary_button_target}>
          <LazyLoad>
            <ResponsivePicture
              mediumData={{
                url: imgSrcs,
                webp_url: webpImgSrcs,
                metadata: {
                  width: 640,
                  height: 640,
                },
              }}
              className="card-img-top"
              altTitle={cmsBlock.title}
            />
          </LazyLoad>
        </a>
      )}
      <CardBody className="d-flex flex-column">
        {cmsBlock.title && (
          <CardTitle tag="h3" className="h5 mb-0">
            {cmsBlock.title}
          </CardTitle>
        )}
        {cmsBlock.content && (
          <div
            className="cmsblock__teaser__content py-2 semi-small"
            dangerouslySetInnerHTML={{ __html: cmsBlock.content }}
          />
        )}
        <Row>
          <Col xs={4} className="d-flex align-items-end">
            {cmsBlock.subtitle}
          </Col>
          <Col xs={8} className="text-right">
            {cmsBlock.primary_button_title && cmsBlock.primary_button_target && (
              <a href={cmsBlock.primary_button_target} className="btn btn-link">
                {cmsBlock.primary_button_title} »
              </a>
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

/** define proptypes for the form */
CMSBlockTeaser.propTypes = {
  /** the item */
  cmsBlock: PropTypes.object.isRequired,
};

/**  define proptype for the 'translation' function  */
CMSBlockTeaser.contextTypes = {
  t: PropTypes.func,
};
export default CMSBlockTeaser;
